<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <el-form ref="form" :rules="rules" :model="form" label-width="160px">
      <el-collapse v-model="activeNames">
        <el-collapse-item title="基础信息" name="1">
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="主体" prop="subject">
                <el-select v-model="form.subject" clearable filterable>
                  <el-option v-for="(item, ind) in subjectList" :key="ind" :label="item.label"
                    :value="item.val"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="项目" prop="project">
                <el-select @change="changeArticle" clearable v-model="form.project" filterable>
                  <el-option v-for="(item, ind) in projectInfoList" :key="ind" :label="item.title"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="应用" prop="appid">
                <el-select @change="changeAppid" v-model="form.appid" clearable @visible-change="cisChange" filterable>
                  <el-option v-for="(item, ind) in application" :key="ind" :label="item.title"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-popover placement="left" width="200" trigger="hover" content="仅在选择一个应用时可用" :disabled="versionPopover">
                <el-form-item label="发布版本" prop="releaseVersion" slot="reference">
                  <el-select v-model="form.releaseVersion" clearable :disabled="versionNum" filterable>
                    <el-option v-for="(item, ind) in versionV2" :key="ind" :value="item" :label="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-popover>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="审核平台" prop="auditPlatform">
                <el-cascader v-model="form.auditPlatform" :options="second_channels" :props="cascaderProps" clearable
                  @change="cascderChange" filterable></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="增长部协作者" prop="increase_admin_id">
                <el-select v-model="form.increase_admin_id" clearable filterable>
                  <el-option v-for="item in authorList" :key="item.id" :label="item.realname"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="异常信息" name="2">
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="核心问题" prop="coreProblem">
                <el-select v-model="form.coreProblem" placeholder="请选择（可多选）" multiple collapse-tags clearable
                  @change="changeCore" filterable>
                  <el-option v-for="(item, ind) in coreProblemList" :key="ind" :label="item.label"
                    :value="item.val"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="风险等级" prop="riskLevel">
                <el-select v-model="form.riskLevel" clearable filterable>
                  <el-option v-for="(item, ind) in riskLevelList" :key="ind" :label="item.label"
                    :value="item.val"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="是否违规" prop="violation">
                <el-select v-model="form.violation" clearable filterable>
                  <el-option v-for="(item, ind) in violationList" :key="ind" :label="item.label"
                    :value="item.val"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="被拒时间" prop="refuseTime">
                <el-date-picker v-model="form.refuseTime" type="date" placeholder="请选择" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :offset="8">
              <el-form-item label="恢复时间">
                <el-date-picker v-model="form.restoreTime" type="date" placeholder="请选择" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <!-- prop="refuseReason" -->
              <el-form-item label="被拒原因/截图">
                <el-input type="textarea" v-model="form.refuseReason" placeholder="请输入" :autosize="{ minRows: 3 }"
                  :maxlength="2000" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="16" :offset="8">
              <el-form-item>
                <ali_upload v-model="form.photoReason" :limit="5" :drag="true" :listType="''" :multiple="true">
                </ali_upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-form-item label="处理策略">
                <el-input type="textarea" v-model="form.processingStrategy" placeholder="请输入" :autosize="{ minRows: 3 }"
                  :maxlength="2000" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
      <el-row style="margin-right: 0; margin-left: 0; background: #fff">
        <el-col :span="21" style="background: #fff; text-align: center">
          <el-form-item style="margin-bottom: 22px">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { Mydata } from "./mixins/index";
import ali_upload from "../component/ali_upload.vue";
import { mapState } from "vuex";
// import store from "store2";
export default {
  components: { ali_upload },
  mixins: [Mydata],
  data() {
    return {
      // 表格项
      form: {
        subject: "", //主体
        project: "", //项目
        appid: "", //应用
        increase_admin_id: "", // 增长部协助者
        releaseVersion: "", //发布版本
        auditPlatform: [], //审核平台
        coreProblem: "", //核心问题
        riskLevel: "", //风险等级
        violation: "", //是否违规
        refuseTime: "", //被拒时间
        restoreTime: "", //恢复时间
        refuseReason: "", //被拒原因
        photoReason: [], //被拒截图
        processingStrategy: "", //处理策略
      },
      department_id: [], //事业群数据

      activeNames: ["1", "2"], //折叠面板默认高亮控制
      appidInfo: {
        appInfo: [], //应用-组件列表数据
      },
      application: [], //应用存储字段
      projectInfo: {
        appInfo: [], //部门-组件件初始数据
      },
      projectInfoList: [], //项目存储字段
      dialogImageUrl: "",
      dialogVisible: false,
      cascaderProps: {
        value: "id",
        label: "title",
        children: "children",
        multiple: false,
        expandTrigger: "hover",
      },
      second_channels: [], //审核异常平台二级选择框
      backSource: {}, //回传数据
      versionV2: [], //版本号
      versionNum: true, //版本号禁用
      versionPopover: false, //提示窗禁用
      channelsSecond: "", //审核异常平台提交数据
      coreFont: "", //核心问题转换后提交字段
      fullscreenLoading: false,
      authorList: []
    };
  },
  computed: {
    ...mapState({
      riskConfirmList: (state) => state.dict_main.review_is_ack,
      coreProblemList: (state) => state.dict_main.review_core_issues,
      riskLevelList: (state) => state.dict_main.review_risk_level,
      violationList: (state) => state.dict_main.review_is_violation,
      subjectList: (state) => state.dict_main.review_subject,
    }),
  },
  mounted() {
    if (localStorage.getItem("rows") !== null) {
      this.fullscreenLoading = true; //开启全屏加载动画
    }
    //获取渠道分类
    this.getClassify();
    this.application = JSON.parse(localStorage.getItem("appinfo"));
    this.projectInfoList = JSON.parse(localStorage.getItem("projectInfo"));
    this.getAuthor()
  },
  //应该在提交表单成功之后,将数据进行移除
  beforeDestroy() {
    localStorage.removeItem("rows");
  },

  methods: {
    //获取渠道分类
    async getClassify() {
      let res = await this.$http.post("Invest_Statistics/classify");
      this.second_channels = res[1];
      this.second_channels.forEach(({ id }) => {
        this.getChannels(id);
      });
    },
    //获取渠道
    async getChannels(id) {
      let [err, res] = await this.$http.post(
        "Invest_Statistics/invest_channels",
        { classify_id: id }
      );
      if (err) return;

      if (id == 1) {
        // this.second_channels[0].children = res[1]
        this.$set(this.second_channels[0], "children", res);
      } else if (id == 2) {
        this.$set(this.second_channels[1], "children", res);
      } else if (id == 4) {
        this.$set(this.second_channels[2], "children", res);
      }

      //为避免second_channels还未拼接完毕再次重新赋值
      if (localStorage.getItem("rows") !== null) {
        this.backSource = JSON.parse(localStorage.getItem("rows"));

        await this.getSource();
      }
    },
    //为回传数据进行赋值操作
    async getSource() {
      await this.dealBack(this.backSource.platform); //处理回显的块联选择
      await this.getVersionV2(this.backSource.appid); //回传后默认获取版本号
      this.versionNum = false;
      this.versionPopover = true;
      //回传显示
      let {
        subject,
        project_id,
        appid,
        version,
        core_issues,
        risk_level,
        is_violation,
        rejected_date,
        resume_date,
        rejected_content,
        handle_tactics,
        increase_admin_id
      } = this.backSource;
      this.form.increase_admin_id = increase_admin_id + ''
      this.form.subject = subject + "";
      this.form.project = project_id;
      this.form.appid = appid + "";
      this.form.releaseVersion = version;
      // this.form.auditPlatform = platform
      this.form.coreProblem = core_issues.split(",");
      this.form.riskLevel = risk_level + "";
      this.form.violation = is_violation + "";
      this.form.refuseTime = rejected_date;
      this.form.restoreTime = resume_date;
      this.form.refuseReason = rejected_content.cause;
      this.form.processingStrategy = handle_tactics;
      this.form.photoReason = rejected_content.image;
      this.fullscreenLoading = false;
    },

    //获取协作者列表
    async getAuthor() {
      let res = await this.$http.post("Operate_Invest/getAuthor");
      this.authorList = res[1].admin;
    },
    //处理块联回显
    dealBack(id) {
      let str = [];
      this.second_channels.forEach(({ children }) => {
        if (children) {
          children.forEach((val) => {
            if (val.id == id) {
              str[0] = val.classify_id;
              str[1] = val.id;
            }
          });
        }

      });
      this.form.auditPlatform = str;
    },
    //表单取消
    cancel() {
      localStorage.setItem("rows", null);
      this.$router.push({
        path: "/business_center/subsidiary_management/app_auditing",
        query: {
          componentName: "Auditingunusual",
          id: 33,
        },
      });
    },
    //核心问题改变字段
    changeCore(val) {
      this.coreFont = val.join(",");
    },
    //表单提交
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let {
            subject,
            project,
            appid,
            releaseVersion,
            auditPlatform,
            coreProblem,
            riskLevel,
            violation,
            refuseTime,
            restoreTime,
            refuseReason,
            photoReason,
            increase_admin_id,
            processingStrategy,
          } = this.form;
         
          let params = {
            increase_admin_id,
            id: this.backSource.id || "",
            subject: subject,
            project_id: project,
            appid: appid,
            version: releaseVersion,
            platform: this.channelsSecond || auditPlatform[1],
            core_issues: this.coreFont || coreProblem.join(","),
            risk_level: riskLevel,
            is_violation: violation,
            rejected_date: refuseTime,
            resume_date: restoreTime || "",
            rejected_content: {
              cause: refuseReason || "",
              image: photoReason || [],
            },
            handle_tactics: processingStrategy || "",
            is_ack:this.backSource.id?this.backSource.is_ack:0
          };
          this.$http.post("/review/add_change", params).then((res) => {
            if (res[3] == "success") {
              this.$message.success("提交成功");
              setTimeout(() => {
                this.cancel();
              }, 200);
            } else {
              this.$message.error(res[0].msg);
            }
          });
        } else {
          this.$message.error("请填写完成后再进行提交");
          return false;
        }
      });
    },
    //改变项目
    changeArticle(val) {
      this.form.appid = "";
      this.form.releaseVersion = "";
      this.projectInfoList.forEach((vals) => {
        if (val == vals.id) {
          this.application = vals.node;
        }
      });
      this.versionNum = true;
      this.versionPopover = false;
    },
    // 筛选应用的回调函数
    changeAppid(val) {
      this.form.releaseVersion = "";
      if (val !== "") {
        this.getVersionV2(val); //联动发布版本
      }

      this.versionNum = false;
      this.versionPopover = true;
    },
    //应用筛选visible-change
    cisChange(val) {
      if (this.form.project == "" && val == true) {
        this.application = JSON.parse(localStorage.getItem("appinfo"));
      }
    },
    //获取版本号
    async getVersionV2(id) {
      let res = await this.$http.post("App/getVersionV2", { appId: id });
      this.versionV2 = Array.from(new Set(res[1]));
    },
    //审核平台变动选择
    cascderChange(val) {
      this.channelsSecond = val[1]?val[1]:val[0];
    },
  },
};
</script>

<style>
.el-upload-dragger {
  margin-top: 22px;
}

.el-collapse-item__header {
  height: 30px;
  background: #ddd;
  padding-left: 10px;
  color: #303133;
}

.el-form-item {
  margin-bottom: 0;
  margin-top: 22px;
}

.el-upload-dragger {
  margin-top: 22px;
}

/* .el-collapse-item__header {
  height: 30px;
  background: #fff;
} */
.el-form-item {
  margin-bottom: 0;
  margin-top: 22px;
}

.el-col-xl-6 {
  margin-bottom: 20px;
}

.el-textarea .el-input__count {
  bottom: 0;
  background: transparent;
}

.el-textarea__inner {
  padding: 5px 15px 30px;
}
</style>
